import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Tooltip } from '@maui/elements'

export const InfoTooltip = ({ tooltip, ...props }) => {
  return (
    <Tooltip
      tooltip={tooltip}
      {...props}
    >
      <Icon cursor="pointer" name="info" size="md" />
    </Tooltip>
  )
}

InfoTooltip.propTypes = {
  tooltip: PropTypes.string,
}
